import { differenceInDays, differenceInHours, parse } from "date-fns";
import _ from 'lodash';
import { useGenericPostRequestQuery } from "../../../../redux/commonRTK";
import { apiConstants } from "../../../../common/constants";
import { useGetSelectedFilters, applyCourierFilters } from "../../../../common/contexts/Filters";
import { getMerchant } from "../../../../helpers/ReduxHelpers";

export const HOUR_BUCKETS = ['>24 hours', '>48 hours', '>72 hours', '>96 hours', '>120 hours', '>144 hours']

function hoursBucket(hoursStuck) {
    if (hoursStuck >= 144) return '>144 hours'
    if (hoursStuck >= 120) return '>120 hours'
    if (hoursStuck >= 96) return '>96 hours'
    if (hoursStuck >= 72) return '>72 hours'
    if (hoursStuck >= 48) return '>48 hours'
    return '>24 hours'
}

export default function useStuckShipments(selectedHour) {

    const { id } = getMerchant();

    const requestPayload = { url: apiConstants.getSnapshotsNotUpdateLastNHours, data: { hours: selectedHour, merchantId: id } };
    const { data: rawData, isLoading, isFetching } = useGenericPostRequestQuery(requestPayload);
    const filters = useGetSelectedFilters()

    if (isLoading || isFetching) return { isLoading: true };

    let data = filters ? applyCourierFilters(rawData, filters) : rawData;
    let uniqCourierNames = _.map(_.uniqBy(data, 'courier'), 'courier');

    const dataGroupedByCourier = _(data)
        .groupBy('courier')
        .map(function (items, name) {
            const row = { name, count: items.length }
            for (const b of HOUR_BUCKETS) row[b] = 0
            for (const item of items) {
                if (!item.lastStatusUpdateTime) continue
                const lastUpdate = parse(item.lastStatusUpdateTime, 'dd-MM-yyyy HH:mm', new Date())
                const hrs = differenceInHours(new Date(), lastUpdate)
                if (hrs < 24) continue
                row[hoursBucket(hrs)] += 1
            }
            return row
        }).value();

    const dataGroupedByStatus = _(data)
        .groupBy('orderStatus')
        .map(function (items, name) {
            const row = { name: name.replace(/_/g, " "), count: items.length }
            for (const b of HOUR_BUCKETS) row[b] = 0
            for (const item of items) {
                if (!item.lastStatusUpdateTime) continue
                const lastUpdate = parse(item.lastStatusUpdateTime, 'dd-MM-yyyy HH:mm', new Date())
                const hrs = differenceInHours(new Date(), lastUpdate)
                if (hrs < 24) continue
                row[hoursBucket(hrs)] += 1
            }
            return row
        }).value();

    const dataGroupedByAgeing = _(data)
        .groupBy(function (item) {

            let dayDiff;
            let key;

            if (item.awbRegisteredDate) {
                dayDiff = differenceInDays(new Date(), parse(item.awbRegisteredDate, 'dd-MM-yyyy HH:mm', new Date()))
            }

            if (dayDiff <= 7) {
                key = '1-7 Days';
            } else if (dayDiff <= 14) {
                key = '8-14 Days';
            } else if (dayDiff <= 21) {
                key = '15-21 Days';
            } else if (dayDiff <= 30) {
                key = '22-30 Days';
            } else {
                key = '30+ Days';
            }


            return key;
        })
        .map(function (items, key) {

            const row = { name: key, count: items.length };
            const groupedByCourier = _.groupBy(items, 'courier');

            for (const courierId of Object.keys(groupedByCourier)) {
                row[courierId] = groupedByCourier[courierId].length;
            }

            return row;
        }).value()

    return { rawData, dataGroupedByAgeing, dataGroupedByCourier, dataGroupedByStatus, uniqCourierNames, isLoading: false }
}